export { EloReceiptIcon } from './receipt-icon'
